import React, { useContext } from 'react';
import { MapControlContext } from '../contexts/mapcontrol.context';
import {
  getAssociatedLevelIDsArrayFromOrdinal
} from '../utils/utils';
import { StyledFloorSelectorControlDiv } from '../Styled';
import useBuildingLevelUtilHooks from '../hooks/useBuildingLevelUtilHooks';
import useLeafletDomEvents from '../hooks/useLeafletDomEvents';
import FloorCountBadge from './FloorCountBadge';
import useMapHooks from '../hooks/useMapHooks';

// determine levels associated with buildings by filtering matching building_ids in levels.geojson.
// each feature returned represents a level or floor for that building
// we then filter the features by unique ordinals,
// sort them numerically,
// loop over sorted levels and render a button only if building has multiple unique ordinals.
export default function FloorSelectorControl() {
  const {
    setFloorSelectedIDArray,
    setClickedMarkerID,
    setSelectedFloorOrdinal,
    selectedFloorOrdinal,
  } = useContext(MapControlContext);

  const { sortedLevelOrdinals, ordinalToLevelFeatures } = useBuildingLevelUtilHooks();
  const { preventLeafletClickPropagation } = useLeafletDomEvents();
  const { fitMapToBoundsOfMultipleGeoJSONs } = useMapHooks();

  function handleFloorSelect(ev: React.SyntheticEvent, levelOrdinal: any) {
    ev.preventDefault();
    preventLeafletClickPropagation(ev.target); // prevent clicks and double clicks propagating & causing zooms.

    const selectedFeatures = ordinalToLevelFeatures[levelOrdinal] ?? [];
    const associatedLevelIDsArray = selectedFeatures.map(f => f.id);

    const selectedLevelFeatureData = ordinalToLevelFeatures[levelOrdinal] ?? [];

    setFloorSelectedIDArray(associatedLevelIDsArray);
    setSelectedFloorOrdinal(levelOrdinal);
    setClickedMarkerID(''); // reset clicked marker ID to hide info boxes.
    fitMapToBoundsOfMultipleGeoJSONs(selectedLevelFeatureData); // center map to feature bounds of selected floor.
  }

  return (
    <StyledFloorSelectorControlDiv data-test-id="floor-selector">
      {sortedLevelOrdinals.map((levelOrdinal: any) => {
        // render a button for each unique ordinal.
        const floorIsSelected = selectedFloorOrdinal === levelOrdinal;

        return (
          <div className="button-container" key={levelOrdinal}>
            <button
              className={floorIsSelected ? '--active' : ''}
              onClick={(ev) => handleFloorSelect(ev, levelOrdinal)}
            >
              {levelOrdinal}
              <FloorCountBadge ordinal={levelOrdinal} />
            </button>
          </div>
        );
      })}
    </StyledFloorSelectorControlDiv>
  );
}
